import BlockHelper from "../../helpers/Block/BlockHelper";
import ResizableForm from '../../../../spine-cms-vue/src/components/mixins/ResizableForm.js';

Vue.asyncComponent('bp-settings-form',{
    mixins: [ResizableForm],
    props: {
        dataProvider: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showConfirm: false,
            confirmCallback: null,
            alertUnsaved: null,
            unsavedChangesMessage: false,
            loading: false,
            formData: false,
            blockToEdit: null,
            resolveBlockTimer: null,
            savingAndClosing: false,
        }
    },
    watch: {
        '$route.fullPath': {
            immediate: true,
            handler() {
                this.formData = false;
                this.resolveBlockToEdit();
            },
        },
    },
    computed: {
        showForm() {
            return this.blockToEdit?.settings?.hasForm;
        },
        settingsTypeParam() {
            return this.blockToEdit?.type
                || this.normalizeRouteParam(this.$route.params.widgetType)
                || this.normalizeRouteParam(this.$route.params.blockType)
                || null;
        },
        resolvedReferenceId() {
            return this.blockToEdit?.referenceId
                || this.normalizeRouteParam(this.$route.params.referenceId)
                || '';
        },
        resolvedHashId() {
            return this.blockToEdit?.id
                || this.normalizeRouteParam(this.$route.params.hashId)
                || this.normalizeRouteParam(this.$route.params.referenceId)
                || '';
        },
        formUrl() {
            return this.dataProvider.getSettingsFormUrl(
                    this.settingsTypeParam,
                    this.$route.query.verticalId,
                    this.$route.params.blueprintId,
                    this.resolvedHashId,
                    this.$route.query.versionId
            );
        },
        saveFormUrl() {
            return this.dataProvider.getSaveSettingsFormUrl(
                    this.settingsTypeParam,
                    this.$route.query.verticalId,
                    this.$route.params.blueprintId,
                    this.resolvedHashId,
                    this.$route.query.versionId
            );
        },
        relationString() {
            return this.$route.params.relationString;
        },
        /**
         * Uniquge id for the width in localstorage
         * @return {string}
         */
        localStorageWidthId() {
            return 'editor-settings-width';
        }
    },
    methods: {
        normalizeRouteParam(value) {
            if (value === null || typeof value === 'undefined') {
                return null;
            }

            const normalizedValue = String(value).trim();

            return normalizedValue === '' || normalizedValue === 'undefined'
                ? null
                : normalizedValue;
        },
        saveSettings($event) {
            this.savingAndClosing = true;
            this.alertUnsaved = false;
            this.unsavedChangesMessage = false;

            const settingsForm = this.$refs.settingsForm;
            if (settingsForm?.formValues) {
                settingsForm.initialFormValues = JSON.parse(JSON.stringify(settingsForm.formValues));
            }

            this.$emit('saveSettings', {...$event, referenceId: this.resolvedReferenceId});

            this.$nextTick(() => {
                this.close();
                this.savingAndClosing = false;
            });
        },
        saveSettingsAndBlueprint($event) {
            const eventData = {...$event, referenceId: this.$route.params.referenceId};

            this.$emit('saveSettings', eventData);
            // The response's updateName event is handled in the current tick. (for form blueprints)
            // Save after it has updated the block used to build the payload.
            this.$nextTick(() => {
                this.$emit('saveBlueprint');
                this.close();
            });
        },
        updateName($event) {
            this.$emit('blockPropertyChanged', {...$event, referenceId: this.resolvedReferenceId});
        },
        confirmDialog() {
            this.showConfirm = false;
            this.confirmCallback();
        },
        alertUnsavedChanges({showAlert, message}) {
            this.alertUnsaved = showAlert;
            this.unsavedChangesMessage = message;
        },
        attemptClose(close) {
            if (this.savingAndClosing) {
                close();
                return;
            }

            if (! this.alertUnsaved) {
                close();
                return;
            }

            this.showConfirm = true;
            this.confirmCallback = close;
        },
        close() {
            // go to the parent route
            this.$router.push({
                ...this.$route.matched[0],
                query: this.$route.query
            });
        },
        getBlock(blocks, id) {
            let result = null;

            // get the block by id recursive
            blocks.forEach(block => {
                if(block.id === id) {
                    result = block;
                }

                if(block.blocks.length) {
                    let childResult = this.getBlock(block.blocks, id);
                    if(childResult) {
                        result = childResult;
                    }
                }
            });

            return result;
        },
        resolveBlockToEdit(attempt = 0) {
            clearTimeout(this.resolveBlockTimer);

            const blocks = this.dataProvider?.getBlocks?.() || [];
            const referenceId = this.normalizeRouteParam(this.$route.params.referenceId);
            const hashId = this.normalizeRouteParam(this.$route.params.hashId);

            let blockToEdit = BlockHelper.getBlock(blocks, referenceId);

            if (! blockToEdit && hashId) {
                blockToEdit = this.getBlock(blocks, hashId);
            }

            // Fallback for malformed dashboard widget routes where the encrypted
            // hash id ended up in the referenceId slot.
            if (! blockToEdit && referenceId) {
                blockToEdit = this.getBlock(blocks, referenceId);
            }

            this.blockToEdit = blockToEdit;

            if (this.showForm) {
                this.getFormData();
                return;
            }

            if (! blockToEdit && attempt < 10) {
                this.resolveBlockTimer = setTimeout(() => {
                    this.resolveBlockToEdit(attempt + 1);
                }, 50);
            }
        },
        /**
         * Get the formData needed for the form
         * @returns {Promise<void>}
         */
        async getFormData() {
            let param = {
                locale: this.$localeHandler.getActiveLocale()
            };
            this.loading = true;

            try {
                const data = {
                    formValues : this.blockToEdit.settings?.values
                };
                this.formData  = await this.$post(this.formUrl, data, param);

                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
        }
    },
    beforeDestroy() {
        clearTimeout(this.resolveBlockTimer);
    }
}, 'blueprints/form/bp-settings-form.html');
